import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'

export default function Loader () {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 4 }}>
      <CircularProgress />
    </Box>
  )
}